import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import RinoNav from "@/components/rino/RinoNav";
import HeroSection from "@/components/rino/HeroSection";
import IntroSection from "@/components/rino/IntroSection";
import ProblemsSection from "@/components/rino/ProblemsSection";
import AppTracksSection from "@/components/rino/AppTracksSection";
import BenefitsSection from "@/components/rino/BenefitsSection";
import DownloadSection from "@/components/rino/DownloadSection";
import RinoFooter from "@/components/rino/RinoFooter";
const Index = () => {
    return (_jsxs("div", { className: "min-h-screen bg-background text-foreground", children: [_jsx(RinoNav, {}), _jsxs("main", { children: [_jsx(HeroSection, {}), _jsx(IntroSection, {}), _jsx(ProblemsSection, {}), _jsx(AppTracksSection, {}), _jsx(BenefitsSection, {}), _jsx(DownloadSection, {})] }), _jsx(RinoFooter, {})] }));
};
export default Index;
